module.exports = __webpack_public_path__ + "assets/img/icon-save-money.b1588fab.svg";